'use strict';

exports.round_factor = function (factor) {
  return Math.ceil(factor);

  // const roundUpToNearest = .25;

  // return Math.ceil(factor * (1 / roundUpToNearest)) / (1 / roundUpToNearest);
}

exports.round_half_down = function (value) {
  return -Math.round(-value);
};

const round_quarter = function (value) {
  let matches = ("" + value).match(/\d*([RGY])/i);

  if (matches) {
    const factorColor = matches[1];

    return round_quarter(("" + value).slice(0, -1)) + factorColor;
  }

  const roundUpToNearest = .25;

  return Math.ceil(value * (1 / roundUpToNearest)) / (1 / roundUpToNearest);
};

exports.round_quarter = round_quarter;
